import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { transactionDatumCellConnection } from "sheets/components/cells/cell-selectors/datum-cell-selectors"
import { Cell } from "fixed-data-table-2"
import { Icon as DSIcon } from "quorumdesign"
import classNames from "classnames"

export const TransactionDatumCell = (props) => (
    <Cell className="transaction parent-child" {...props}>
        <span>{props.entityAssociatedWithTransaction}</span>
    </Cell>
)
TransactionDatumCell.propTypes = {
    entityAssociatedWithTransaction: PropTypes.string,
}

export default connect(transactionDatumCellConnection)(TransactionDatumCell)
